import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';

@Component
export class StyleWatcher extends Vue {
  selector!: string;
  styleProp!: string;
  
  public styleValue: string | number = 0;
  private debouncedUpdateStyle = debounce(this.updateStyle, 10);

  get computedStyle(): string | number {
    return this.styleValue;
  }

  private updateStyle(): void {
    const target = document.querySelector(this.selector);
    if (target) {
      const computedStyle = window.getComputedStyle(target);
      const value = computedStyle[this.styleProp as keyof CSSStyleDeclaration] as string;
      
      // Try to parse as number if possible
      const numericValue = parseFloat(value as string);
      this.styleValue = isNaN(numericValue) ? value : numericValue;
    }
  }

  @Watch('selector')
  onSelectorChange() {
    this.updateStyle();
  }

  @Watch('styleProp')
  onStylePropChange() {
    this.updateStyle();
  }
  @Watch('$i18n.locale')
  localeChange() {
    this.updateStyle();
  }

  mounted(): void {
    this.updateStyle();
    window.addEventListener('resize', this.debouncedUpdateStyle);

  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.debouncedUpdateStyle);
    this.debouncedUpdateStyle.cancel();
  }
} 